// import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   countUnreadMessagesByDoctor,
//   listenForMessages,
//   listenForPatientsList,
//   markMessagesAsSeen,
//   sendMessage,
// } from "../../../Services/chatService";
// import { DECREASECOUNT } from "../../../Redux/actions/ChatActions.js";
// import { useDebouncedValue, useLoggedInDoctor } from "./doctorChatHelpers";
// import {
//   useUnreadCounts,
//   useResolvedPatients,
//   usePatientSearch,
// } from "./useDoctorChatData";
// import ConversedPatientsList from "./ConversedPatientsList";
// import AllPatientsList from "./AllPatientsList";
// import ChatWindow from "./ChatWindow";

// // "Where did the user open this chat from" — drives back-navigation target.
// const ORIGIN = {
//   CONVERSED_LIST: "conversedList",
//   ALL_PATIENTS_LIST: "allPatientsList",
// };

// function LiveChat() {
//   const loggedUser = useLoggedInDoctor();
//   const doctorId = loggedUser?.user?.userId;
//   const dispatch = useDispatch();

//   // --- view state ---
//   const [view, setView] = useState(ORIGIN.CONVERSED_LIST); // 'conversedList' | 'allPatientsList' | 'chat'
//   const [chatOrigin, setChatOrigin] = useState(ORIGIN.CONVERSED_LIST);
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [messages, setMessages] = useState([]);

//   // --- conversed list state ---
//   const [patientIds, setPatientIds] = useState([]);
//   const [conversedSearch, setConversedSearch] = useState("");
//   const unreadCounts = useUnreadCounts(doctorId);
//   const resolvedPatients = useResolvedPatients(patientIds);

//   const visibleConversedPatients = useMemo(() => {
//     if (!conversedSearch) return resolvedPatients;
//     const key = conversedSearch.toLowerCase();
//     return resolvedPatients.filter((p) => p.firstName?.toLowerCase().includes(key));
//   }, [resolvedPatients, conversedSearch]);

//   // --- all-patients search view state ---
//   const [allPatientsSearch, setAllPatientsSearch] = useState("");
//   const debouncedSearch = useDebouncedValue(allPatientsSearch, 350);
//   const patientSearch = usePatientSearch(debouncedSearch);

//   const messagesUnsubscribeRef = useRef(null);

//   useEffect(() => {
//     if (!doctorId) return;
//     const unsubscribe = listenForPatientsList(doctorId, setPatientIds);
//     return () => unsubscribe();
//   }, [doctorId]);

//   useEffect(() => {
//     return () => {
//       messagesUnsubscribeRef.current?.();
//     };
//   }, []);

//   const refreshUnreadBadgeCount = useCallback(async () => {
//     if (!doctorId) return;
//     const counts = await countUnreadMessagesByDoctor(doctorId);
//     const total = Object.values(counts).reduce((sum, n) => sum + n, 0);
//     dispatch({ type: DECREASECOUNT, payload: total });
//   }, [doctorId, dispatch]);

//   const openChat = useCallback(
//     (patient, origin) => {
//       messagesUnsubscribeRef.current?.();

//       setSelectedPatient(patient);
//       setMessages([]);
//       setChatOrigin(origin);
//       setView("chat");

//       markMessagesAsSeen(doctorId, patient?.patientId);
//       refreshUnreadBadgeCount();

//       messagesUnsubscribeRef.current = listenForMessages(
//         patient?.patientId,
//         doctorId,
//         setMessages
//       );
//     },
//     [doctorId, refreshUnreadBadgeCount]
//   );

//   const handleSelectFromConversed = useCallback(
//     (patient) => openChat(patient, ORIGIN.CONVERSED_LIST),
//     [openChat]
//   );

//   const handleSelectFromAllPatients = useCallback(
//     (patient) => openChat(patient, ORIGIN.ALL_PATIENTS_LIST),
//     [openChat]
//   );

//   // FIX: previously this always returned to the conversed list regardless
//   // of where the chat was opened from. Now it returns to chatOrigin.
//   const handleBack = useCallback(async () => {
//     if (selectedPatient) {
//       markMessagesAsSeen(doctorId, selectedPatient.patientId);
//       await refreshUnreadBadgeCount();
//     }
//     setView(chatOrigin);
//     setSelectedPatient(null);
//   }, [doctorId, selectedPatient, chatOrigin, refreshUnreadBadgeCount]);

//   // FIX: previously called listenForMessages again after sending, leaking
//   // a second pair of onSnapshot listeners every send. The existing
//   // subscription (set up in openChat) already receives the new message
//   // via Firestore's real-time update, so sending just needs to write.
//   const handleSendMessage = useCallback(
//     async (text) => {
//       await sendMessage(doctorId, selectedPatient?.patientId, text);
//     },
//     [doctorId, selectedPatient]
//   );

//   const handleOpenAllPatients = useCallback(() => {
//     setView(ORIGIN.ALL_PATIENTS_LIST);
//   }, []);

//   const handleBackFromAllPatients = useCallback(() => {
//     setView(ORIGIN.CONVERSED_LIST);
//     setAllPatientsSearch("");
//   }, []);

//   if (!loggedUser) {
//     return null; // not logged in — nothing to render
//   }

//   if (view === "chat" && selectedPatient) {
//     return (
//       <ChatWindow
//         patient={selectedPatient}
//         doctorId={doctorId}
//         messages={messages}
//         onBack={handleBack}
//         onSendMessage={handleSendMessage}
//       />
//     );
//   }

//   if (view === ORIGIN.ALL_PATIENTS_LIST) {
//     return (
//       <AllPatientsList
//         patients={patientSearch.results}
//         isLoading={patientSearch.loading}
//         error={patientSearch.error}
//         unreadCounts={unreadCounts}
//         onSelectPatient={handleSelectFromAllPatients}
//         onBack={handleBackFromAllPatients}
//         onSearchChange={(e) => setAllPatientsSearch(e.target.value)}
//       />
//     );
//   }

//   return (
//     <ConversedPatientsList
//       patients={visibleConversedPatients}
//       isLoading={resolvedPatients.length === 0 && patientIds.length > 0}
//       unreadCounts={unreadCounts}
//       onSelectPatient={handleSelectFromConversed}
//       onOpenAllPatients={handleOpenAllPatients}
//       onSearchChange={(e) => setConversedSearch(e.target.value)}
//     />
//   );
// }

// export default LiveChat;

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  countUnreadMessagesByDoctor,
  listenForMessages,
  listenForPatientsList,
  markMessagesAsSeen,
  sendMessage,
} from "../../../Services/chatService";
import { DECREASECOUNT } from "../../../Redux/actions/ChatActions.js";
import { useDebouncedValue, useLoggedInDoctor } from "./doctorChatHelpers";
import {
  useUnreadCounts,
  useResolvedPatients,
  usePatientSearch,
} from "./useDoctorChatData";
import ConversedPatientsList from "./ConversedPatientsList";
import ChatWindow from "./ChatWindow";

function LiveChat() {
  const loggedUser = useLoggedInDoctor();
  const doctorId = loggedUser?.user?.userId;
  const dispatch = useDispatch();

  const [view, setView] = useState("list"); // 'list' | 'chat'
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [messages, setMessages] = useState([]);

  const [patientIds, setPatientIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebouncedValue(searchTerm, 350);

  const unreadCounts = useUnreadCounts(doctorId);
  const resolvedPatients = useResolvedPatients(patientIds); // conversed patients
  const patientSearch = usePatientSearch(debouncedSearch);   // searches ALL patients

  const isSearching = debouncedSearch.trim().length > 0;

  // Empty box -> recent conversations. Typing -> global search, same as WhatsApp:
  // results include patients you've never messaged before.
  const visiblePatients = isSearching ? patientSearch.results : resolvedPatients;
  const isLoading = isSearching
    ? patientSearch.loading
    : resolvedPatients.length === 0 && patientIds.length > 0;

  const messagesUnsubscribeRef = useRef(null);

  useEffect(() => {
    if (!doctorId) return;
    const unsubscribe = listenForPatientsList(doctorId, setPatientIds);
    return () => unsubscribe();
  }, [doctorId]);

  useEffect(() => {
    return () => {
      messagesUnsubscribeRef.current?.();
    };
  }, []);

  const refreshUnreadBadgeCount = useCallback(async () => {
    if (!doctorId) return;
    const counts = await countUnreadMessagesByDoctor(doctorId);
    const total = Object.values(counts).reduce((sum, n) => sum + n, 0);
    dispatch({ type: DECREASECOUNT, payload: total });
  }, [doctorId, dispatch]);

  const openChat = useCallback(
    (patient) => {
      messagesUnsubscribeRef.current?.();

      setSelectedPatient(patient);
      setMessages([]);
      setView("chat");

      markMessagesAsSeen(doctorId, patient?.patientId);
      refreshUnreadBadgeCount();

      // If no conversation exists yet, this just resolves to an empty
      // message list and starts listening — first sendMessage creates it.
      messagesUnsubscribeRef.current = listenForMessages(
        patient?.patientId,
        doctorId,
        setMessages
      );
    },
    [doctorId, refreshUnreadBadgeCount]
  );

  const handleBack = useCallback(async () => {
    if (selectedPatient) {
      markMessagesAsSeen(doctorId, selectedPatient.patientId);
      await refreshUnreadBadgeCount();
    }
    setView("list");
    setSelectedPatient(null);
    setSearchTerm(""); // back to a clean recent-chats view, like WhatsApp
  }, [doctorId, selectedPatient, refreshUnreadBadgeCount]);

  const handleSendMessage = useCallback(
    async (text) => {
      await sendMessage(doctorId, selectedPatient?.patientId, text);
    },
    [doctorId, selectedPatient]
  );

  if (!loggedUser) return null;

  if (view === "chat" && selectedPatient) {
    return (
      <ChatWindow
        patient={selectedPatient}
        doctorId={doctorId}
        messages={messages}
        onBack={handleBack}
        onSendMessage={handleSendMessage}
      />
    );
  }

  return (
    <ConversedPatientsList
      patients={visiblePatients}
      isLoading={isLoading}
      error={isSearching ? patientSearch.error : null}
      unreadCounts={unreadCounts}
      searchTerm={searchTerm}
      isSearching={isSearching}
      onSelectPatient={openChat}
      onSearchChange={(e) => setSearchTerm(e.target.value)}
      onClearSearch={() => setSearchTerm("")}
    />
  );
}

export default LiveChat;